import React from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function PurchaseSection() {
  const PURCHASE_LINK = 'https://pay.hotmart.com/Q104345987V?checkoutMode=10';
  return <div id="compra" className="bg-white rounded-2xl shadow-xl border-2 border-amber-200 p-8 md:p-12 max-w-4xl mx-auto text-center relative overflow-hidden" data-id="element-27">
      {/* Decorative background element */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-amber-300 via-amber-500 to-amber-300" data-id="element-28"></div>

      <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-29">
        Empieza a encontrar respuestas hoy mismo
      </h2>
      <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-30">
        No tienes que esperar. No tienes que saber más. Solo empezar.
      </p>

      <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-10" data-id="element-31">
        <div className="text-center" data-id="element-32">
          <p className="text-gray-400 text-lg line-through mb-1" data-id="element-33">
            Precio normal: $27.99
          </p>
          <div className="flex items-center justify-center gap-2" data-id="element-34">
            <span className="text-5xl font-bold text-amber-600" data-id="element-35">$13.99</span>
            <span className="text-sm font-semibold bg-green-100 text-green-700 px-2 py-1 rounded" data-id="element-36">
              50% OFF
            </span>
          </div>
          <p className="text-sm text-gray-500 mt-2" data-id="element-37">
            Pago único. Acceso de por vida.
          </p>
        </div>
      </div>

      <a href={PURCHASE_LINK} className="inline-flex items-center justify-center w-full md:w-auto bg-green-600 hover:bg-green-700 text-white text-xl md:text-2xl font-bold py-4 px-12 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 animate-pulse-subtle" data-id="element-38">
        👉 Quiero acceso inmediato
      </a>

      <div className="mt-8 flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-gray-500" data-id="element-39">
        <div className="flex items-center gap-2" data-id="element-40">
          <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-41" />
          <span data-id="element-42">Garantía de 7 días</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-43">
          <Lock className="w-5 h-5 text-green-600" data-id="element-44" />
          <span data-id="element-45">Pago 100% Seguro</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-46">
          <CreditCard className="w-5 h-5 text-green-600" data-id="element-47" />
          <span data-id="element-48">Acceso Inmediato</span>
        </div>
      </div>

      <div className="mt-6 pt-6 border-t border-gray-100" data-id="element-49">
        <img src="https://cdn.magicpatterns.com/uploads/pgLv3BGXpTLsG1U4Tnx3jP/payment_methods.png" alt="Métodos de pago seguros" className="h-8 mx-auto opacity-60 grayscale hover:grayscale-0 transition-all" onError={e => {
        // Fallback if image fails, just hide it or show text
        ;
        (e.target as HTMLImageElement).style.display = 'none';
      }} data-id="element-50" />
        <p className="text-xs text-gray-400 mt-2" data-id="element-51">
          Tu compra está procesada por Hotmart, la plataforma más segura de
          Latinoamérica.
        </p>
      </div>
    </div>;
}